import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { BezoekInhoud } from "@/components/bezoeken/BezoekInhoud";

export default function BezoekPagina() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [b, setB] = useState(null);
  const [vraag, setVraag] = useState(false);
  const magWeg = b && user.role !== "bedrijfsleider" && (b.om === user.username || user.role === "oversight");
  const weg = async () => {
    try { await api.delete(`/bezoeken/${id}`); toast.success("Bezoek verwijderd"); navigate("/bezoeken"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Verwijderen mislukt"); }
  };
  return (
    <div data-testid="bezoek-pagina" className="max-w-3xl space-y-4">
      <div className="flex items-center gap-2">
        <Link to="/bezoeken" data-testid="bezoek-terug" className="min-h-[44px] inline-flex items-center gap-1.5 text-sm font-semibold text-blue-700 hover:text-blue-900"><ArrowLeft className="h-4 w-4" />Alle bezoeken</Link>
        {magWeg && <button type="button" data-testid="bezoek-verwijderen" onClick={() => setVraag(true)} className="ml-auto min-h-[44px] inline-flex items-center gap-1.5 px-3 rounded-md border border-zinc-300 text-sm text-rose-700 hover:bg-rose-50"><Trash2 className="h-4 w-4" />Verwijderen</button>}
      </div>
      <BezoekInhoud id={id} onGeladen={setB} />
      <AlertDialog open={vraag} onOpenChange={setVraag}>
        <AlertDialogContent data-testid="bezoek-verwijder-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Bezoek verwijderen?</AlertDialogTitle>
            <AlertDialogDescription>Het bezoek verdwijnt voor iedereen. Oversight kan het terugzetten.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuleren</AlertDialogCancel>
            <AlertDialogAction data-testid="bezoek-verwijder-bevestig" onClick={weg} className="bg-rose-600 hover:bg-rose-700">Verwijderen</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
